module.exports = __webpack_public_path__ + "static/Harri-60746f0e292683bd7e00a7546b74233c.jpg";